<template>
  <div class="form-group no-margin row mr-2">
    <div class="col-auto">
      <label class="col-form-label">{{ label }}</label>
    </div>
    <div class="col-auto">
      <b-button-group>
        <b-button :pressed="btnType==0" variant="primary" @click="search(0,txt)">전체</b-button>
        <b-button :pressed="btnType==1" variant="primary" @click="search(1,txt)">초등학교</b-button>
        <b-button :pressed="btnType==2" variant="primary" @click="search(2,txt)">중학교</b-button>
        <b-button :pressed="btnType==3" variant="primary" @click="search(3,txt)">고등학교</b-button>
        <b-button v-show="txt != 'txt'" :pressed="btnType==4" variant="primary" @click="search(4,txt)">교과서</b-button>
        <b-button v-show="txt != 'txt'" :pressed="btnType==5" variant="primary" @click="search(5,txt)">ELT</b-button>
      </b-button-group>
    </div>
  </div>
</template>

<script>
import {reactive, ref, computed, watch, onMounted, onUnmounted} from '@vue/composition-api';

export default {
  props: {
    data: {},
    txt:'',
    label: "",
  },
  components: {},
  setup(props, context) {
    const btnType = ref(0);
    return {
      btnType,
      ...actions(props.data, context)
    }
  }
}

function actions(data, context) {
  function search(btnType , txtType) {
    this.btnType = btnType;

    if(txtType == 'txt'){ // 교과서 관리 : 초/중/고
      data.params.bookTypeCd = "330001";

      const allSchoolKeys = ['schlE1ChkYn', 'schlE2ChkYn', 'schlE3ChkYn', 'schlE4ChkYn', 'schlE5ChkYn', 'schlE6ChkYn',
        'schlM1ChkYn', 'schlM2ChkYn', 'schlM3ChkYn', 'schlH1ChkYn', 'schlH2ChkYn', 'schlH3ChkYn'];
      const elSchoolKeys = allSchoolKeys.filter((item) => item.indexOf('schlE') > -1);
      const midSchoolKeys = allSchoolKeys.filter((item) => item.indexOf('schlM') > -1);
      const highSchoolKeys = allSchoolKeys.filter((item) => item.indexOf('schlH') > -1);
      const schoolKeys = [elSchoolKeys, midSchoolKeys, highSchoolKeys];

      if (btnType == 0) { // 전체
        allSchoolKeys.forEach((key) => {
          data.params[key] = null;
        });
      } else if (btnType == 1 || btnType == 2 || btnType == 3) { //초등, 중등, 고등
        allSchoolKeys.forEach((key) => {
          data.params[key] = 'N';
        });
        schoolKeys[btnType-1].forEach((key) => {
          data.params[key] = 'Y';
        });
      }
    }else{ // 참고서 관리 : 초/중/고 및 '교과서', 'ELT'
      data.params.bookTypeCd = "330002";

      const cateCdList = [null, '356001', '356002', '356003', '356004', '356005'];
      data.params.cateCd = cateCdList[btnType];
    }
     context.emit('search');
  }

  return {search}
}
</script>
